export default "__VITE_ASSET__BejB_xLu__"